import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Setup from "@/pages/Setup";
import Dettaglio from "@/pages/Dettaglio";
import ImportBlocco from "@/pages/ImportBlocco";
import ParserAdmin from "@/pages/ParserAdmin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/setup"
            element={
              <ProtectedRoute>
                <Setup />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cliente/:codice/:anno/:mese"
            element={
              <ProtectedRoute>
                <Dettaglio />
              </ProtectedRoute>
            }
          />
          <Route
            path="/import-blocco"
            element={
              <ProtectedRoute>
                <ImportBlocco />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/parsers"
            element={
              <ProtectedRoute>
                <ParserAdmin />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
